(function() {
    window.addEventListener('load', () => {
        // Patch pour l'ouverture en nouvel onglet de tous les liens externe, voir CORE-7411
        document.querySelectorAll('a.lien_externe, a.quick-access__link').forEach(function(a){
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener noreferrer');
        });
    });
})();